
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  fetch: async function () {
    await this.initFilterFromUrl();
    await this.getArticles(1);
    await this.getTags();
  },

  head: function () {
    const setHead = this.setHead;
    const title = setHead?.title || "Наш опыт — перевозки грузов";
    const description = setHead?.description || `Ознакомьтесь с последними новостями и выполненными перевозками различных грузов в ${this.cityName}, России и СНГ. Осуществляются перевозки грузов транспортной компанией Central Trans по РФ с гарантией качества`;

    return {
      title: title,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },

  data: function () {
    return {
      articles: [],
      tags: [],

      filter: {
        'filter[tag_id]': ''
      },
      pagination: {
        page: 1,
        totalPage: 1
      },

      isLoad: true
    }
  },

  components: {
    Breadcrumbs,

    ArticleCard: () => import("~/components/articles/ArticleCard"),
    ArticleCardLoading: () => import("~/components/articles/ArticleCardLoading"),
  },

  computed: {
    breadcrumbs: function () {
      return [
        { title: "Главная", path: "/" },
        { title: "Наш опыт", path: this.$route.fullPath },
      ]
    },

    setHead: function () {
      const article = this.articles?.[0] || {};
      const articleSeo = article?.category || {};

      return {
        title: articleSeo?.seo_title,
        description: articleSeo?.seo_description,
      }
    },
    cityName: function () {
      return this.$store.state?.appState?.config?.city?.data?.city_name;
    }
  },

  methods: {
    getTags: async function () {
      const res = await this.$api.agent.transport.get('/articles/tags?per-page=999&filter[has_articles]=1&filter[has_category_id]=1').then((res) => {
        return res.data
      }).catch(() => {
        return []
      });
      this.tags = res;
    },
    getArticles: async function (newPage) {
      this.isLoad = true;

      const page = newPage || this.$route.query?.page || this.pagination.page;
      const filterTag = Boolean(this.filter["filter[tag_id]"]) ? `filter[tag_id]=${this.filter["filter[tag_id]"]}` : "";
      const response = await this.$api.agent.transport.get(`/articles?page=${page}&filter[category_slug]=news&expand=tags,category&${ filterTag }`).then((res) => {
        return res
      }).catch(() => {
        return {}
      });

      const pagination = {
        page: Number.parseFloat(response?.headers?.['x-pagination-current-page'] || 1),
        totalPage: Number.parseFloat(response?.headers?.['x-pagination-page-count'] || 1)
      };
      const articles = response?.data || [];
      this.setSearchParams(pagination.page);

      this.articles = articles;
      this.pagination = pagination;
      this.isLoad = false;
    },
    changePage: async function (newPage) {
      let pagination = {...this.pagination}
      pagination.page = newPage;
      this.pagination = pagination;

      const listPosition = this.$refs.refList.getBoundingClientRect()?.top + document.body.scrollTop;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });

      await this.getArticles(newPage);
    },
    changeTag: async function (newTag) {
      let filter = {...this.filter};
      if (filter['filter[tag_id]'] === newTag) {
        filter['filter[tag_id]'] = "";
      } else {
        filter['filter[tag_id]'] = newTag;
      }
      this.filter = filter;

      const listPosition = this.$refs.refList.getBoundingClientRect()?.top + document.body.scrollTop;
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });

      await this.getArticles(1);
    },
    setSearchParams: function (page) {
      if (!process.client) {
        return
      }

      let search = [
        `page=${page}`
      ];
      Object.keys(this.filter).map((key) => {
        const value = this.filter[key];
        if (!!value) {
          search.push(`${key}=${value}`)
        }
      });
      window.history.replaceState(null, null, `${window.location?.pathname}?${search.join("&")}`)
    },

    initFilterFromUrl: function () {
      let filter = {...this.filter};

      const query = this.$route?.query;
      if (query['filter[tag_id]']) {
        filter['filter[tag_id]'] = Number.parseFloat(query['filter[tag_id]']);
      }

      this.filter = filter;
    },
  },
}
